import {Component, forwardRef, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import * as moment from 'moment';
import * as _ from 'lodash';

@Component({
  selector: 'app-form-input-calendar',
  templateUrl: './form-input-calendar.component.html',
  styleUrls: ['./form-input-calendar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormInputCalendarComponent),
      multi: true
    }
  ]
})
export class FormInputCalendarComponent implements OnInit, ControlValueAccessor {
  @Input() appendTo: string;
  @Input() field: string;
  @Input() formControl: FormControl;
  @Input() label: string;
  @Input() maxDate: Date;
  @Input() minDate: Date;
  @Input() mode: any;
  @Input() seconds: boolean;
  @Input() time: boolean;

  public calendarValue: any;
  public calendarValueInitial: any;
  public id: string;

  public onChange = (_: any) => {
  }
  public onTouch = () => {
  }

  constructor() {
  }

  // function to restart input value
  public clear(): void {
    this.calendarValue = this.calendarValueInitial;
  }

  // function to catch input changes and update form in parent
  public onInput($event: any): void {
    this.onTouch();
    this.onChange(this.calendarValue);
  }

  ngOnInit(): void {
    this.id = `${this.field}-${moment().unix()}`;
    if (this.formControl.value) {
      this.calendarValue = this.formControl.value;
    }
    this.calendarValueInitial = this.calendarValue ? _.clone(this.calendarValue) : '';
  }

  // value accessor functions
  writeValue(value: any): void {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
}
